import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

/** The product's section/group label: a quiet mono-uppercase eyebrow that sits ABOVE a card, with an
 *  optional right-aligned meta node (a count or context) that uses the row width for real information.
 *  This is the chosen section-title treatment across the product — it supersedes the old Quiet
 *  `SectionHeader` (h2) for labelling a region — so section labels read identically on every surface. */
export function SectionLabel({
  children,
  meta,
  className,
}: {
  children: ReactNode;
  meta?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("mb-2.5 flex items-center justify-between gap-3 px-1", className)}>
      <span className="eyebrow">{children}</span>
      {meta ? <div className="flex items-center gap-3">{meta}</div> : null}
    </div>
  );
}
